"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Components = require("./Components");
var _Difference = _interopRequireDefault(require("./Difference"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _constants = require("../../constants");
var _constants2 = require("./constants");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var GgCell = function GgCell(_ref) {
  var field = _ref.field,
    _ref$formattedValue = _ref.formattedValue,
    formattedValue = _ref$formattedValue === void 0 ? {} : _ref$formattedValue,
    _ref$colDef = _ref.colDef,
    colDef = _ref$colDef === void 0 ? {} : _ref$colDef,
    _ref$row = _ref.row,
    row = _ref$row === void 0 ? {} : _ref$row,
    onStart = _ref.onStart,
    onStop = _ref.onStop,
    rowNode = _ref.rowNode;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var value = formattedValue.value,
    compareValue = formattedValue.compareValue,
    valueColor = formattedValue.valueColor,
    compareValueColor = formattedValue.compareValueColor,
    percentValue = formattedValue.percentValue,
    comparePercentValue = formattedValue.comparePercentValue,
    icon = formattedValue.icon,
    compareIcon = formattedValue.compareIcon,
    difference = formattedValue.difference,
    tooltip = formattedValue.tooltip,
    compareTooltip = formattedValue.compareTooltip;
  var align = colDef.align,
    editableCell = colDef.editableCell,
    onEditCell = colDef.onEditCell,
    dotted = colDef.dotted,
    isHighlightLower = colDef.isHighlightLower,
    placeholder = colDef.placeholder,
    disableText = colDef.disableText;
  var isTotalValue = row.isTotalValue;
  var editable = editableCell && !isTotalValue;
  var handleEdit = (0, _react.useCallback)(function () {
    onStart();
    onEditCell({
      col: field,
      value: value,
      rowData: row,
      onStop: onStop
    });
  }, [onStart, onEditCell, field, value, row, onStop]);
  var withCompare = compareValue !== undefined;
  var handleMoveEnter = (0, _react.useCallback)(function () {
    setTouched(true);
  }, [setTouched]);
  var safePlaceholder = (0, _hooks.useValidPlaceholder)(placeholder, rowNode);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Components.CellWrapper, {
    "data-cy": _constants2.dataCy,
    onClick: editable ? handleEdit : undefined,
    editable: editable,
    onMouseEnter: handleMoveEnter,
    children: [(0, _isNumber["default"])(difference) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Difference["default"], {
      value: difference,
      isHighlightLower: isHighlightLower
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Components.ValueWrapper, {
      align: align,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Components.CellValue, {
        icon: icon,
        value: value,
        editable: editable,
        dotted: dotted,
        percentValue: percentValue,
        lineClamp: withCompare ? 1 : 2,
        tooltip: touched && tooltip,
        dataCy: _constants2.dataCyValue,
        placeholder: safePlaceholder,
        color: valueColor,
        disableText: disableText,
        align: align
      }), withCompare ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Components.CellValue, {
        dataCy: _constants2.dataCyCompareValue,
        value: compareValue,
        percentValue: comparePercentValue,
        lineClamp: 1,
        icon: compareIcon,
        placeholder: safePlaceholder,
        color: compareValueColor,
        disableText: disableText,
        tooltip: compareTooltip,
        align: align,
        mt: 4
      }) : null]
    })]
  });
};

// TODO: add component for CellValue
// props: value, icon, subTitle, subIcon, link, disableIcons???
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(GgCell, _constants.compareProps);